if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };
      this.mql = window.matchMedia('(min-width: 750px)');

      // --- Always listen for slide changes when a viewer exists ---
      if (this.elements.viewer) {
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );
      }

      // --- Thumbnail-specific wiring (when thumbnails exist) ---
      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          const btn = mediaToSwitch.querySelector('button');
          if (btn) {
            btn.addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true)
            );
          }
        });
        if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) {
          this.removeListSemantic();
        }
      } else {
        // --- No thumbnails (mosaic / 2-col stacked): enable stacked autoplay logic ---
        this.bindStackedListeners();
      }
    }

    onSlideChanged(event) {
      if (!event || event.detail == null || event.detail.currentElement == undefined) return;
      if (!this.elements.thumbnails) return;

      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      );
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      if (!this.elements.viewer) return;

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
        el.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider && typeof this.elements.viewer.resetPages === 'function') {
          this.elements.viewer.resetPages();
        }
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        const btn = element.querySelector('button');
        if (btn) btn.removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      const tbtn = thumbnail.querySelector('button');
      if (tbtn) tbtn.setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      if (this.elements.thumbnails.slider) {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem && activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace('[index]', position);
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    // --- Enhanced: also play native <video>, not only deferred media ---
    playActiveMedia(activeItem) {
      if (!activeItem) return;
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();

      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }

      // Play native <video> if present (covers stacked/mosaic and already-loaded slides)
      setTimeout(() => {
        const v = activeItem.querySelector('video');
        if (!v) return;
        try {
          v.muted = true; v.setAttribute('muted', '');
          v.playsInline = true; v.setAttribute('playsinline', '');
          v.autoplay = true; v.loop = true;
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(() => { v.setAttribute('controls', ''); });
        } catch (e) { /* no-op */ }
      }, 40);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    }

    // =========================
    // Helpers for 2-col / mosaic
    // =========================
    autoplayVisible = () => {
  const viewer = this.elements && this.elements.viewer;
  if (!viewer) return;

  const items = viewer.querySelectorAll('.product__media-item');
  let target = null;

  for (const item of items) {
    const r = item.getBoundingClientRect();
    const inViewY = r.bottom > 64 && r.top < (window.innerHeight - 64);
    const inViewX = r.right > 0 && r.left < window.innerWidth; // NEW
    const inView = inViewX && inViewY;                          // NEW
    if (!inView) continue;

    if (item.querySelector('deferred-media') || item.querySelector('video')) {
      target = item;
      break;
    }
  }
  if (!target) return;

  // Pause other videos in this gallery only
  viewer.querySelectorAll('video').forEach(v => {
    if (!target.contains(v)) { try { v.pause(); } catch(_) {} }
  });

  // Inject <video> if still deferred
  const dm = target.querySelector('deferred-media');
  if (dm && typeof dm.loadContent === 'function' && !target.querySelector('video')) {
    try { dm.loadContent(false); } catch(_) {}
  }

  // Play
  setTimeout(() => {
    const v = target.querySelector('video');
    if (!v) return;
    try {
      v.muted = true; v.setAttribute('muted','');
      v.playsInline = true; v.setAttribute('playsinline','');
      v.autoplay = true; v.loop = true;
      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(() => { v.setAttribute('controls',''); });
    } catch(_) {}
  }, 40);
};

    bindStackedListeners = () => {
      // Initial attempt
      this.autoplayVisible();

      // Keep it honest as the page changes
      const throttle = (fn, t = 150) => {
        let id; return () => { clearTimeout(id); id = setTimeout(fn, t); };
      };
      const rerun = throttle(this.autoplayVisible, 150);

      window.addEventListener('scroll', rerun, { passive: true });
      window.addEventListener('resize', rerun);

      // Variant changes (common event names)
      document.addEventListener('variant:change', () => setTimeout(this.autoplayVisible, 60));
      document.addEventListener('product:variant-change', () => setTimeout(this.autoplayVisible, 60));

      // Closing the zoom/media modal → resume gallery video
      document.addEventListener('click', (e) => {
        if (
          e.target.closest('.product-media-modal__toggle') ||
          e.target.closest('.media-modal__close') ||
          e.target.closest('[data-media-modal-close]') ||
          e.target.closest('.quick-view__close')
        ) { setTimeout(this.autoplayVisible, 80); }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.keyCode === 27) setTimeout(this.autoplayVisible, 80);
      });
    };
  });
}
